import { css } from '@emotion/react';
import { Col, colors, Content, Row, Title, RadioButtonGroup, Space } from 'common-components';
import { useAppTranslation } from '@hooks';

const Header = ({ selectedValue, setSelectedValue }) => {
  const { translate } = useAppTranslation();
  const texts = [
    {
      type: 'tablePageTitle',
      content: translate('navigation.projects'),
    },
    {
      type: 'tablePageSubtitle',
      content: translate('projects.subtitle'),
    },
  ];

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'middle'}
        css={css`
          margin: 16px 0;
        `}
      >
        <Col>
          <Row justify={'space-between'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space key={`title-${text.content}-${index}`} align={'center'}>
                      <Title style={{ fontSize: 18, lineHeight: '28px', color: colors.black }}>
                        {text.content}
                      </Title>
                    </Space>
                  );
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                );
              })}
            </Col>
          </Row>
        </Col>
        <Col>
          <RadioButtonGroup
            size="md"
            items={[
              { value: '1', label: translate('projects.displayModes.cards') },
              { value: '2', label: translate('projects.displayModes.list') },
            ]}
            value={selectedValue}
            defaultValue={selectedValue}
            onChange={(e) => {
              setSelectedValue(e.target.value);
            }}
          />
        </Col>
      </Row>
    </Content>
  );
};

export default Header;
